<div class="search-wrap">
    @if (showSettingsOption) {
    <button type="button" mat-icon-button class="searchFilter search" (click)="openSearchOptions()">
        <mat-icon>manage_search</mat-icon>
    </button>
    }
    <ng-select
            class="ft-search-box ft-topbar-search-select"
            #box
            [items]="results"
            bindLabel="systemHeader.summaryName"
            (change)="onChange($event)"
            (keyup.enter)="onEnter()"
            (keyup)="onKeyPress($event)"
            (scroll)="onScroll($event)"
            (scrollToEnd)="onScrollToEnd()"
            [loading]="loading"
            (blur)="onFocusOut()"
            (focus)="onFocusIn()"
            (paste)="onPaste()"
            [virtualScroll]="true"
            appendTo="body"
            outsideClickEventType="mousedown"
            [typeahead]="typeahead"
            [readonly]="disableGeneralSearch"
            (mousedown)="disableEnableGeneralSearch($event)"
            [(ngModel)]="selectedResult">
                  <ng-template ng-footer-tmp>
                      <small class="search-text-status">
                          Loaded&nbsp;<b>{{loaded}}&nbsp;</b> of&nbsp;<b>{{totalResults}}</b>
                      </small>
                  </ng-template>
                  <ng-template ng-header-tmp>
                      @if (!errorMessage) {
                      <small class="search-text-status">
                          Searching for:&nbsp;<b class="text-ellipsis">{{txt}}</b>
                      </small>
                      }
                      @if (errorMessage) {
                      <small class="search-text-status-error">
                          {{errorMessage}}
                      </small>
                      }
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      @if (item) {
                      <span [ftOptionHighlight]="search">
                        {{ (item.systemHeader && item.systemHeader.summaryName) ?
                            item.systemHeader.summaryName : 'Document ' + item.documentId }}
                      </span>
                      }
                </ng-template>
          </ng-select>
          @if (filter) {
          <button type="button" mat-icon-button matSuffix  class="searchFilter" (click)="removeFilter()">
              <mat-icon>filter_list</mat-icon>
          </button>
          }
           <button type="button" mat-icon-button matSuffix class="searchFilter search" (click)="search()">
              <mat-icon>search</mat-icon>
          </button>

   </div>
